import DropdownMenu from '@atlaskit/dropdown-menu';
import AkIconQuestionCircle from '@atlaskit/icon/glyph/question-circle';
import Immutable from 'immutable';
import React, { Component } from 'react';

import * as analytics from 'common/utils/analytics/analytics';
import {
  customerDropdownItems,
  developerDropdownItems,
  helpItems,
} from '../../../../constants/dropdownGroups';

export default class HelpDropdown extends Component {
  onItemActivate(menuItem) {
    analytics.trackHelpActionClicked(menuItem.item.content);
    if (menuItem.item.onActivate) {
      menuItem.item.onActivate();
    }
  }

  render() {
    const items = Immutable.OrderedSet([
      developerDropdownItems.set('heading', 'Developers'),
      customerDropdownItems.set('heading', 'Customers'),
      helpItems,
    ]);

    return (
      <div className="help-menu">
        <DropdownMenu
          items={items.toJS()}
          appearance="tall"
          position="bottom right"
          onItemActivated={this.onItemActivate}
        >
          <a className="help-dropdown-trigger">
            <div className="question-icon">
              <AkIconQuestionCircle label="Help" secondaryColor="inherit" size="medium" />
            </div>
            <span>Help</span>
          </a>
        </DropdownMenu>
      </div>
    );
  }
}
